import { Constants } from './Constants';
import * as InternalTypes from './InternalTypes';
import { Util } from './Util';

export class ScopeCheck {
	public static hasAnyScopeItemConfigured(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isUserInitiatedFeedbackPossible(startupConfig) || this.isAnyPushFeatureActive(startupConfig);
	}

	public static isScopeItemActive(startupConfig: InternalTypes.StartupConfig, expectedScopeItem: string): boolean {
		if (startupConfig?.scopeSet?.includes(expectedScopeItem)) {
			return true;
		}
		return false;
	}

	public static isAnyPushFeatureActive(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isAppPushAvailable(startupConfig) || this.isTimedPushAvailable(startupConfig) || this.isInstantPushAvailable(startupConfig);
	}

	public static isUserInitiatedScopeSetActive(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isScopeItemActive(startupConfig, Constants.SCOPE_USER_INITIATED);
	}

	public static isAppPushScopeSetActive(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isScopeItemActive(startupConfig, Constants.SCOPE_APP_PUSH);
	}

	public static isTimedPushScopeSetActive(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isScopeItemActive(startupConfig, Constants.SCOPE_TIMED_PUSH);
	}

	public static isInstantPushScopeSetActive(startupConfig: InternalTypes.StartupConfig): boolean {
		return this.isScopeItemActive(startupConfig, Constants.SCOPE_INSTANT_PUSH);
	}

	public static isTestModeActive(): boolean {
		return Util.isUrlParamActive(Constants.URL_PARAM_TEST_MODE, 'true');
	}

	public static isUserInitiatedFeedbackPossible(startupConfig: InternalTypes.StartupConfig): boolean {
		if (this.containsUserInitiatedUrlParam() || this.isUserInitiatedScopeSetActive(startupConfig)) {
			return true;
		}
		return false;
	}

	public static isAppPushAvailable(startupConfig: InternalTypes.StartupConfig): boolean {
		if ((this.containsAppPushUrlParam() || this.isAppPushScopeSetActive(startupConfig)) && Util.isLocalStorageAvailable()) {
			return true;
		}
		return false;
	}

	public static isTimedPushAvailable(startupConfig: InternalTypes.StartupConfig): boolean {
		if ((this.containsTimedPushUrlParam() || this.isTimedPushScopeSetActive(startupConfig)) && Util.isLocalStorageAvailable()) {
			return true;
		}
		return false;
	}

	public static isInstantPushAvailable(startupConfig: InternalTypes.StartupConfig): boolean {
		if ((this.containsInstantPushUrlParam() || this.isInstantPushScopeSetActive(startupConfig)) && Util.isLocalStorageAvailable()) {
			return true;
		}
		return false;
	}

	public static isScopeSetUrlParamDefined(): boolean {
		return Util.isUrlParamDefined(Constants.URL_PARAM_SCOPE_SET);
	}

	public static containsUserInitiatedUrlParam(): boolean {
		return this.isScopeSetUrlParamDefined() && Util.containsUrlParam(Constants.URL_PARAM_SCOPE_SET, Constants.SCOPE_USER_INITIATED);
	}

	public static containsAppPushUrlParam(): boolean {
		return this.isScopeSetUrlParamDefined() && Util.containsUrlParam(Constants.URL_PARAM_SCOPE_SET, Constants.SCOPE_APP_PUSH);
	}

	public static containsTimedPushUrlParam(): boolean {
		return this.isScopeSetUrlParamDefined() && Util.containsUrlParam(Constants.URL_PARAM_SCOPE_SET, Constants.SCOPE_TIMED_PUSH);
	}

	public static containsInstantPushUrlParam(): boolean {
		return this.isScopeSetUrlParamDefined() && Util.containsUrlParam(Constants.URL_PARAM_SCOPE_SET, Constants.SCOPE_INSTANT_PUSH);
	}
}
